export default __webpack_public_path__ + "static/media/heart.f7824f5e.svg";